// src/data/comedians/jim-carrey.js

const base = {
  id: 'jim-carrey',
  slug: 'jim-carrey',
  name: 'Jim Carrey',
  birthYear: 1962,
  image: require('@/assets/images/img_Jim_Carrey.jpg'),
  famousWorks: [
    'Ace Ventura: Pet Detective (1994)',
    'The Mask (1994)',
    'Dumb and Dumber (1994)',
    'Liar Liar (1997)',
    'The Truman Show (1998)',
    'Man on the Moon (1999)',
    'Eternal Sunshine of the Spotless Mind (2004)',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'Canadian-American',
    shortBio: 'Rubber-faced comedy genius',
    bio: `Jim Carrey is a Canadian-American actor and comedian known for his energetic slapstick performances and elastic facial expressions. He became one of the biggest comedy stars of the 1990s with his unique brand of physical comedy.\n\nBorn in Newmarket, Ontario, Carrey developed his comedy skills performing in Toronto comedy clubs. After moving to Los Angeles, he landed a role on the sketch comedy show "In Living Color", which showcased his incredible range of characters and impressions.\n\nCarrey's breakthrough in film came with "Ace Ventura: Pet Detective" (1994), followed by a string of hits. He later demonstrated his dramatic range in "The Truman Show" and "Eternal Sunshine of the Spotless Mind", proving himself one of his generation's most versatile performers.`,
    style: 'Extreme physical comedy, exaggerated facial expressions, improvisational genius',
    achievements: [
      'Two Golden Globe Awards',
      'First actor to earn $20 million for a single film',
      'Hollywood Walk of Fame star',
      'MTV Movie Awards for Best Comedic Performance',
      'Successful painter and political cartoonist',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Canadien-américain',
    shortBio: 'Génie de la comédie au visage élastique',
    bio: `Jim Carrey est un acteur et comédien canadien-américain connu pour ses performances de slapstick débordantes d'énergie et ses expressions faciales élastiques. Il est devenu l'une des plus grandes stars comiques des années 1990 avec son style de comédie physique unique.\n\nNé à Newmarket en Ontario, Carrey a développé ses talents comiques dans les clubs de comédie de Toronto. Après s'être installé à Los Angeles, il a décroché un rôle dans l'émission de sketchs "In Living Color", qui a mis en valeur son incroyable registre.\n\nSa percée au cinéma est venue avec "Ace Ventura" (1994). Il a ensuite démontré sa polyvalence dramatique dans "The Truman Show" et "Eternal Sunshine of the Spotless Mind".`,
    style: 'Comédie physique extrême, expressions faciales exagérées, génie de l\'improvisation',
    achievements: [
      'Deux Golden Globe Awards',
      'Premier acteur à gagner 20 millions de dollars pour un seul film',
      'Étoile sur le Hollywood Walk of Fame',
      'MTV Movie Awards pour la meilleure performance comique',
      'Peintre et caricaturiste politique accompli',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Canadiense-americano',
    shortBio: 'Genio de la comedia de rostro elástico',
    bio: `Jim Carrey es un actor y comediante canadiense-americano conocido por sus energéticas actuaciones de slapstick y sus expresiones faciales elásticas. Se convirtió en una de las mayores estrellas de la comedia de los años 90 con su estilo único de comedia física.\n\nNacido en Newmarket, Ontario, Carrey desarrolló sus habilidades cómicas actuando en clubes de comedia de Toronto. Tras mudarse a Los Ángeles, consiguió un papel en el programa de sketches "In Living Color".\n\nSu gran salto al cine llegó con "Ace Ventura" (1994). Posteriormente demostró su versatilidad dramática en "The Truman Show" y "Eternal Sunshine of the Spotless Mind".`,
    style: 'Comedia física extrema, expresiones faciales exageradas, genio de la improvisación',
    achievements: [
      'Dos Golden Globe Awards',
      'Primer actor en ganar 20 millones de dólares por una sola película',
      'Estrella en el Paseo de la Fama de Hollywood',
      'MTV Movie Awards al mejor rendimiento cómico',
      'Exitoso pintor y caricaturista político',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'كندي-أمريكي',
    shortBio: 'عبقري الكوميديا ذو الوجه المطاط',
    bio: `جيم كاري ممثل وكوميدي كندي-أمريكي يشتهر بأدائه الاستعراضي المفعم بالحركة وتعابير وجهه المرنة التي لا مثيل لها. أصبح أحد أكبر نجوم الكوميديا في التسعينيات بأسلوبه الفريد في الكوميديا الجسدية.\n\nوُلد في نيوماركت بأونتاريو، وطوّر موهبته الكوميدية في نوادي الكوميديا بتورنتو. بعد انتقاله إلى لوس أنجلوس، حصل على دور في برنامج المقاطع الكوميدية "In Living Color" الذي أبرز مدى موهبته.\n\nجاء اختراقه السينمائي مع "Ace Ventura" (1994)، ثم أثبت تنوعه الدرامي في "The Truman Show" و"Eternal Sunshine of the Spotless Mind".`,
    style: 'كوميديا جسدية متطرفة، تعابير مبالغ فيها، عبقرية الارتجال',
    achievements: [
      'جائزتا Golden Globe',
      'أول ممثل يحصل على 20 مليون دولار لفيلم واحد',
      'نجمة على ممشى المشاهير في هوليوود',
      'جائزة MTV لأفضل أداء كوميدي',
      'رسام ورسام كاريكاتير سياسي ناجح',
    ],
  },
];
